module.exports = __webpack_public_path__ + "static/swarmkeeper_mtg_clb-ffae88f35ead2ddda6ee841b694f62af.webp";